export const DIRTY_LABELS = {
  psychotherapy: 'private',
}
